import { render, staticRenderFns } from "./HospitalIntroHzsy.vue?vue&type=template&id=5941f7da&scoped=true"
import script from "./HospitalIntroHzsy.vue?vue&type=script&lang=js"
export * from "./HospitalIntroHzsy.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroHzsy.vue?vue&type=style&index=0&id=5941f7da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5941f7da",
  null
  
)

export default component.exports